import {
    Category,
    CategoryNew,
    CategoryView,
    GetAllQueryParams,
    UpdateCategory,
} from "../interfaces/category";

import axiosInstance from "./axios-instance";

const getScopedAccountId = (accountId?: number): number => {
    if (typeof window === "undefined") {
        return Number(accountId || 0);
    }
    const ownerAccountId = Number(localStorage.getItem("ownerAccountId") || "0");
    if (ownerAccountId > 0) {
        return ownerAccountId;
    }
    if (Number(accountId) > 0) {
        return Number(accountId);
    }
    return Number(localStorage.getItem("accountId") || "0");
};

const getAll = async (queryParams?: GetAllQueryParams) => {
    try {
        const scopedAccountId = getScopedAccountId(queryParams?.accountId);
        const response = await axiosInstance.get<Category[]>("/category", {
            params: {
                ...queryParams,
                accountId: scopedAccountId,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching categories:", error);
        throw error;
    }
};

const getRecord = async ({ recordId }: { recordId: number }) => {
    try {
        const scopedAccountId = getScopedAccountId();
        const response = await axiosInstance.get<CategoryView>(
            `/category/${recordId}?accountId=${scopedAccountId}`
        );
        return response.data;
    } catch (error) {
        console.error("Error adding new category:", error);
        throw error;
    }
};

const addRecord = async (payload: CategoryNew) => {
    try {
        const scopedAccountId = getScopedAccountId(payload.accountId);
        const response = await axiosInstance.post<Category>(
            `/category?accountId=${scopedAccountId}`,
            payload
        );
        return response;
    } catch (error) {
        console.error("Error adding new category:", error);
        throw error;
    }
};

const updateRecord = async (payload: UpdateCategory) => {
    try {
        const scopedAccountId = getScopedAccountId(payload.accountId);
        const response = await axiosInstance.put<UpdateCategory>(
            `/category/${payload.id}?accountId=${scopedAccountId}`,
            payload
        );
        return response;
    } catch (error) {
        console.error("Error updating category:", error);
        throw error;
    }
};

export { getAll, getRecord, addRecord, updateRecord };
